import CheckboxInput from './CheckboxInput';

export default CheckboxInput;
